/* Entrada, cadastro e saída do sistema.

   Dois caminhos levam para dentro: o acesso que o administrador cria no
   painel do Supabase, e o autocadastro com código de convite.

   Nos dois casos quem libera é o Postgres, nunca esta tela. Conta criada
   sem convite nasce inativa (migração 005) e não enxerga nem grava nada.
   Por isso existe a tela de acesso bloqueado: ela é a saída para quem
   criou a conta e ainda não usou um código, inclusive quando o projeto
   exige confirmação de e-mail e a sessão só aparece no login seguinte. */

import { sb } from "./supabase.js";
import { S } from "./estado.js";
import { $ } from "./util.js";
import { codigoValido, usarConvite } from "./api/convites.js";

/* Enquanto o cadastro está em curso o app não pode arrancar no meio do
   caminho: a conta acabou de nascer inativa e só vira ativa alguns instantes
   depois, quando o código é consumido. */
let cadastrando = false;

/* ------------------------------------------------------------- as telas */

export function mostrarLogin(){
  $("#telaApp").hidden = true;
  $("#telaBloqueado").hidden = true;
  $("#telaLogin").hidden = false;
  setTimeout(() => { const c = $("#lEmail"); if (c && !c.value) c.focus(); }, 80);
}

/* Conta existe, mas ainda não está ligada ao escritório. */
export function mostrarTravado(msg){
  $("#telaApp").hidden = true;
  $("#telaLogin").hidden = true;
  $("#telaBloqueado").hidden = false;
  aviso("#tvErro", msg || "");
  setTimeout(() => $("#tvCod")?.focus(), 80);
}

function trocarCaixa(qual){
  $("#cxLogin").hidden    = qual !== "login";
  $("#cxCadastro").hidden = qual !== "cadastro";
  aviso("#loginErro", ""); aviso("#cadErro", "");
  setTimeout(() => (qual === "login" ? $("#lEmail") : $("#cNome"))?.focus(), 60);
}

/* Mostra ou esconde uma faixa de recado. tipo "ok" pinta de verde. */
function aviso(sel, txt, tipo){
  const el = $(sel);
  if (!el) return;
  el.classList.toggle("ok", tipo === "ok");
  if (!txt){ el.hidden = true; return; }
  el.querySelector("span").textContent = txt;
  el.hidden = false;
}

/* --------------------------------------------------------- as mensagens */

function erroEntrada(msg){
  if (/Invalid login/i.test(msg))       return "E-mail ou senha não conferem. Confira e tente de novo.";
  if (/Email not confirmed/i.test(msg)) return "Esse usuário ainda não foi confirmado. Quem administra precisa marcar Auto Confirm no Supabase.";
  return "Não deu para entrar agora: " + msg;
}

function erroCadastro(msg){
  if (/already registered|already exists/i.test(msg)) return "Já existe uma conta com esse e-mail. Se ela é sua, use a tela de entrar.";
  if (/Password should be/i.test(msg))                return "A senha precisa de pelo menos 6 caracteres.";
  if (/Signups not allowed|signup_disabled/i.test(msg)) return "O cadastro está desligado no servidor. Avise quem administra o painel.";
  if (/valid email|invalid format/i.test(msg))        return "Esse e-mail não parece válido. Confira a digitação.";
  if (/rate limit|too many/i.test(msg))               return "Muitas tentativas seguidas. Espere um minuto e tente de novo.";
  return "Não deu para criar o acesso agora: " + msg;
}

const RECADO_CODIGO = "Esse código não existe ou já foi usado. Confira com quem mandou ele para você.";

/* ------------------------------------------------------------ as ajudas */

/* Botão Mostrar da senha. */
function ligarOlho(idBotao, idCampo){
  const b = $(idBotao), i = $(idCampo);
  if (!b || !i) return;
  b.addEventListener("click", () => {
    const oculto = i.type === "password";
    i.type = oculto ? "text" : "password";
    b.textContent = oculto ? "Ocultar" : "Mostrar";
    b.setAttribute("aria-label", oculto ? "Ocultar senha" : "Mostrar senha");
    i.focus();
  });
}

/* Código de convite é sempre maiúsculo e sem espaço: evita metade dos
   erros de quem digita o que chegou pelo WhatsApp. */
function ligarCampoCodigo(sel){
  const el = $(sel);
  if (el) el.addEventListener("input", () => {
    el.value = el.value.toUpperCase().replace(/[^A-Z0-9]/g, "");
  });
}

function ligarAjudas(){
  ligarOlho("#verSenha", "#lSenha");
  ligarOlho("#verSenha2", "#cSenha");
  ligarCampoCodigo("#cCod");
  ligarCampoCodigo("#tvCod");
  ["keydown","keyup"].forEach(ev => $("#lSenha").addEventListener(ev, e => {
    $("#caps").hidden = !(e.getModifierState && e.getModifierState("CapsLock"));
  }));
  $("#lSenha").addEventListener("blur", () => { $("#caps").hidden = true; });
  $("#irCadastro").addEventListener("click", () => trocarCaixa("cadastro"));
  $("#irLogin").addEventListener("click",    () => trocarCaixa("login"));
}

/* ---------------------------------------------------------- o cadastro  */

function ligarCadastro(){
  $("#formCadastro").addEventListener("submit", async e => {
    e.preventDefault();
    const b = $("#cBtn");
    const codigo = $("#cCod").value.trim().toUpperCase();
    const dados = {
      nome:     $("#cNome").value.trim(),
      telefone: $("#cTel").value.trim(),
      pix:      $("#cPix").value.trim(),
      pix_tipo: $("#cPixTipo").value
    };

    aviso("#cadErro", "");
    b.disabled = true; b.textContent = "Criando...";

    try {
      /* Conferir antes evita criar uma conta que já nasce travada por causa
         de um erro de digitação. Quem decide de verdade é o banco, depois. */
      if (!await codigoValido(codigo)) throw new Error("CODIGO");

      cadastrando = true;
      const { data, error } = await sb.auth.signUp({
        email: $("#cEmail").value.trim(),
        password: $("#cSenha").value,
        options: { data: dados }
      });
      if (error) throw error;

      /* Sem sessão quer dizer que o projeto exige confirmação de e-mail.
         O código continua em aberto e vai ser pedido no primeiro login. */
      if (!data.session){
        cadastrando = false;
        b.disabled = false; b.textContent = "Criar meu acesso";
        trocarCaixa("login");
        $("#lEmail").value = $("#cEmail").value.trim();
        aviso("#loginErro", "Conta criada. Confirme o e-mail que você recebeu, entre aqui e digite o código de convite uma vez só.", "ok");
        return;
      }

      if (await usarConvite(codigo)){ location.reload(); return; }

      /* Alguém usou o mesmo código no meio do caminho. A conta existe e a
         sessão também, então a saída é a tela de acesso bloqueado. */
      cadastrando = false;
      b.disabled = false; b.textContent = "Criar meu acesso";
      mostrarTravado("Sua conta foi criada, mas o código já tinha sido usado por outra pessoa. Peça um novo ao escritório e digite aqui.");

    } catch (err){
      cadastrando = false;
      b.disabled = false; b.textContent = "Criar meu acesso";
      aviso("#cadErro", err.message === "CODIGO" ? RECADO_CODIGO : erroCadastro(err.message || String(err)));
    }
  });
}

/* ------------------------------------------------- a tela de bloqueado  */

function ligarTravado(){
  $("#tvBtn").addEventListener("click", async () => {
    const codigo = $("#tvCod").value.trim().toUpperCase();
    if (!codigo){ aviso("#tvErro", "Digite o código que você recebeu."); return; }

    const b = $("#tvBtn");
    b.disabled = true; b.textContent = "Liberando...";
    try {
      if (!await usarConvite(codigo)) throw new Error("CODIGO");
      location.reload();
    } catch (e){
      b.disabled = false; b.textContent = "Liberar acesso";
      aviso("#tvErro", e.message === "CODIGO" ? RECADO_CODIGO : "Não deu para liberar agora: " + (e.message || e));
    }
  });

  $("#tvSair").addEventListener("click", async () => {
    await sb.auth.signOut();
    location.reload();
  });
}

/* ------------------------------------------------------------ o arranque */

/* aoEntrar roda assim que existe sessão válida. */
export function ligarLogin(aoEntrar){
  ligarAjudas();
  ligarCadastro();
  ligarTravado();

  $("#formLogin").addEventListener("submit", async e => {
    e.preventDefault();
    const b = $("#lBtn");
    b.disabled = true; b.textContent = "Entrando...";
    aviso("#loginErro", "");

    const { error } = await sb.auth.signInWithPassword({
      email: $("#lEmail").value.trim(),
      password: $("#lSenha").value
    });

    b.disabled = false; b.textContent = "Entrar";
    if (error){
      aviso("#loginErro", erroEntrada(error.message));
      $("#lSenha").focus(); $("#lSenha").select();
    }
  });

  $("#btnSair").addEventListener("click", async () => {
    await sb.auth.signOut();
    location.reload();
  });

  /* Importante: o supabase-js mantém um cadeado interno enquanto este callback
     roda. Chamar o banco aqui dentro trava a consulta para sempre. O setTimeout
     joga o trabalho para fora do callback e solta o cadeado. */
  sb.auth.onAuthStateChange((_e, sessao) => {
    if (sessao?.user){
      S.usuario = sessao.user;
      if (!cadastrando) setTimeout(aoEntrar, 0);
    } else {
      S.usuario = null;
      mostrarLogin();
    }
  });

  (async () => {
    const { data } = await sb.auth.getSession();
    if (data.session?.user){ S.usuario = data.session.user; aoEntrar(); }
    else mostrarLogin();
  })();
}
